import { ProcessingOverlay, RouteElement } from '@components'

import { Color } from '@billy/design-system'
import { ReactElement } from 'react'
import ReactDOM from 'react-dom'
import { Route as V6Route, Routes as V6Routes } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { OnboardingSetupContextProvider } from '../../contexts/OnboardingSetupContext'
import { StepRouter } from './elements/StepRouter'
import * as Styled from './styles'

export const OnboardingSetup = (): ReactElement | null => {
  const { organization } = useUserOrganization()

  if (!organization) {
    return null
  }

  // Render into document.body so the overlay isn't clipped by ContentArea and can cover the nav menu too
  return ReactDOM.createPortal(
    <OnboardingSetupContextProvider>
      <Styled.FullScreenOverlay>
        {/* No <Switch>: index and :step are mutually exclusive by definition. CompatRoute can't
            be used for the :step route: it always wraps its content in a v5 RouterRoute, which
            does its own v5 match against the full, un-stripped pathname - but this area is
            mounted under ViewContainer's non-exact /*-wildcard route (see ViewContainer.tsx),
            which strips that matched prefix before matching here. A relative path satisfies the
            outer v6 match but then fails CompatRoute's inner v5 match (needs the absolute path),
            and an absolute path fails the outer v6 match instead - neither works. Bare v6
            Route+RouteElement (no v5 layer involved) is the only combination where a single
            relative path works correctly. */}
        <V6Routes>
          <V6Route index element={<ProcessingOverlay color={Color.White} withAnimation />} />
          <V6Route
            path=":step/*"
            element={
              <RouteElement>
                <StepRouter />
              </RouteElement>
            }
          />
        </V6Routes>
      </Styled.FullScreenOverlay>
    </OnboardingSetupContextProvider>,
    document.body,
  )
}
